import React from 'react'
import IconLabel from '../../common/icon-label'
import { CartDash } from 'react-bootstrap-icons'
import moment from 'moment'

const DropCutoff = ({ experience = {} }) => {
    if (experience.dropCutoff === undefined) {
        return null
    }
    const cutoff = moment(experience.date).subtract(experience.dropCutoff, 'days').endOf('day')
    const ended = moment().isAfter(cutoff)
    const label = `Droppable ${ended ? 'ended' : 'until'}`
    return (
        <IconLabel
            icon={CartDash}
        >
            <small>{label} {cutoff.format('ddd, MMM Do h:mm a')}</small>
        </IconLabel>
    )
}

export default DropCutoff
